"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setData = setData;
exports.fixType = fixType;
exports.setDataValue = setDataValue;
const checkType_1 = require("./checkType");
const defaultValue_1 = require("./defaultValue");
const defineSchema_1 = require("./defineSchema");
const capitalize_1 = require("../methods/capitalize");
const check_1 = require("../methods/check");
const fdatetime_1 = require("../methods/fdatetime");
const mround_1 = require("../methods/mround");
const IOptions_1 = require("../WrappedProperty/IOptions");
/**
 * ustawienie danych zgodnie ze schematem
 *
 * @export
 * @param {JSONSchema} schema schemat
 * @param {*} data obiekt reprezentujący dane docelowe
 * @param {*} value dane do zapisu
 * @param {(string | string[])} [path] ścieżka
 * @param {number} [pathIndex=0] indeks na ścieżce (dane wewnętrzne)
 * @param {*} [Vue] konktruktor Vue
 * @param {boolean} [fixArraySize] czy ustawiać nowy rozmiar tablicyw  przypadku tablic
 * @returns {boolean} czy udało się ustawić
 */
function setData(schema, data, value, path, pathIndex = 0, fixArraySize, options = IOptions_1.defaultOptions, currentPath = '') {
    if (path) {
        if (typeof path === 'string') {
            path = path
                .replace(/\[/g, '.')
                .replace(/\]/g, '')
                .split('.')
                .filter((x) => x);
            pathIndex = 0;
            // mssql path fix
            if (path[pathIndex] == '$') {
                pathIndex++;
            }
        }
        const cpath = path[pathIndex];
        if (cpath) {
            if (schema.type === 'object') {
                const dschema = schema.properties[cpath];
                if (dschema !== undefined) {
                    const ppath = currentPath ? currentPath + '.' + cpath : cpath;
                    if (dschema.type === 'object' || dschema.type === 'array') {
                        let data2 = data[cpath];
                        if (data2 === undefined) {
                            data2 = (0, defaultValue_1.defaultValue)(dschema, true, undefined, options, ppath);
                            data[cpath] = data2;
                        }
                        return setData(dschema, data2, value, path, pathIndex + 1, fixArraySize, options, ppath);
                    }
                    else {
                        return setDataValue(dschema, data, cpath, value);
                    }
                }
                else {
                    return false;
                }
            }
            else if (schema.type === 'array') {
                const dschema = schema.items;
                if (dschema !== undefined) {
                    const index = parseInt(cpath, 10);
                    const data2 = data[index];
                    if (data2 === undefined) {
                        while (data.length < index + 1) {
                            data.push((0, defaultValue_1.defaultValue)(dschema, true, undefined, options, currentPath + '[' + data.length + ']'));
                        }
                        // data2 = data[index];
                    }
                    if (dschema.type === 'array' || dschema.type === 'object') {
                        return setData(dschema, data[index], value, path, pathIndex + 1, fixArraySize, options, currentPath + '[' + index + ']');
                    }
                    else {
                        return setDataValue(dschema, data, index, value);
                    }
                }
                else {
                    return false;
                }
            }
            else {
                return false;
            }
        }
    }
    if (schema.type === 'object') {
        return setDataObj(schema, data, value, fixArraySize, options, currentPath);
    }
    else {
        return setDataArray(schema, data, value, fixArraySize, options, currentPath);
    }
}
/**
 * dopasowanie typu danych na podstawie schematu
 *
 * @param {JSONSchema} schema schemat
 * @param {*} value dane do zapisu
 * @returns {*} nowa wartość
 */
function fixType(schema, value) {
    if (value != null) {
        switch (schema.type) {
            case 'array':
                if (!Array.isArray(value)) {
                    return [value];
                }
                break;
            case 'object': {
                if (!(0, defineSchema_1.isObject)(value)) {
                    if (typeof value === 'string') {
                        try {
                            return JSON.parse(value);
                        }
                        catch (_a) {
                            return undefined;
                        }
                    }
                    else {
                        return undefined;
                    }
                }
                break;
            }
            case 'number':
            case 'money':
            case 'integer':
                if (typeof value === 'string') {
                    value = +value.replace(',', '.');
                    if (isNaN(value)) {
                        return undefined;
                    }
                }
                if (typeof value === 'number') {
                    if (schema.precision && typeof schema.precision === 'number') {
                        value = (0, mround_1.mround)(value, schema.precision);
                    }
                    else {
                        switch (schema.type) {
                            case 'integer':
                                value = (0, mround_1.mround)(value, 0);
                                break;
                            case 'money':
                                value = (0, mround_1.mround)(value, 2);
                                break;
                            case 'number':
                                value = (0, mround_1.mround)(value, 8);
                                break;
                        }
                    }
                }
                break;
            case 'boolean':
                if (typeof value === 'string') {
                    value = value !== 'false' && value !== 'off' && value !== '';
                }
                else if (typeof value === 'number') {
                    value = value != 0;
                }
                break;
            case 'string':
                if (typeof value === 'number') {
                    value = '' + value;
                }
                else if (typeof value === 'boolean') {
                    value = value ? 'true' : 'false';
                }
                else if (typeof value === 'object') {
                    if (value instanceof Date) {
                        value = (0, fdatetime_1.fdatetime)(value);
                    }
                    else {
                        let svalue = '' + value;
                        if (svalue === '[object Object]') {
                            svalue = JSON.stringify(value);
                        }
                        value = svalue;
                    }
                }
                if (typeof value === 'string') {
                    switch (schema.format) {
                        case 'uppercase':
                            value = value.toLocaleUpperCase();
                            break;
                        case 'lowercase':
                            value = value.toLocaleLowerCase();
                            break;
                        case 'capitalize':
                            value = (0, capitalize_1.capitalize)(value);
                            break;
                        case 'date':
                            if (value && value.length > 10) {
                                value = value.substring(0, 10);
                            }
                            if (!(0, check_1.check)('date', value)) {
                                value = '';
                            }
                            break;
                        case 'date-time':
                            if (value.indexOf('Z') > -1) {
                                const dt = new Date(value);
                                if (!isNaN(dt.getTime())) {
                                    value = (0, fdatetime_1.fdatetime)(new Date(value));
                                }
                                else {
                                    value = '';
                                }
                            }
                            else if (value.indexOf('T') === 10) {
                                value = value.replace('T', ' ');
                            }
                            if (value.length < 19) {
                                if (value.length >= 10) {
                                    value = value.substring(0, 10) + ' 00:00:00';
                                }
                            }
                            if (!(0, check_1.check)('date-time', value)) {
                                value = '';
                            }
                            break;
                    }
                }
        }
    }
    return value;
}
/**
 * ustawia proste dane
 *
 * @export
 * @param {JSONSchema} schema schemat
 * @param {*} parent obiekt docelowy
 * @param {*} key klucz
 * @param {*} value nowa wartość
 * @param {*} [Vue] konsktruktor Vue
 * @returns {boolean} czy udało się ustawić
 */
function setDataValue(schema, parent, key, value) {
    // fix type
    if (value != undefined) {
        value = fixType(schema, value);
        if (value == undefined)
            return false;
    }
    if ((0, checkType_1.checkType)(schema, value)) {
        parent[key] = value;
        return true;
    }
    return false;
}
/**
 * ustawia dane tablicowe
 *
 * @param {JSONSchema} schema schemat
 * @param {any[]} destArray docelowa tablica
 * @param {any[]} value nowa wartość
 * @param {*} [Vue] konsktruktor Vue
 * @param {boolean} [fixArraySize] czy ustawić nowy rozmiar tablicy
 * @returns {boolean} czy udało się ustawić
 */
function setDataArray(schema, destArray, value, fixArraySize, options = IOptions_1.defaultOptions, currentPath = '') {
    if (value === undefined)
        return false;
    //if (!Array.isArray(value)) return false;
    //fixType
    if ((value = fixType(schema, value)) === undefined)
        return false;
    const sitems = schema.items;
    if (fixArraySize) {
        while (destArray.length > value.length) {
            destArray.splice(destArray.length - 1, 1);
        }
    }
    let destIndex = 0;
    for (let i = 0; i < value.length; i++) {
        const prevItem = destArray[i];
        if (prevItem) {
            destIndex = i;
        }
        let newItem;
        const ppath = currentPath + '[' + i + ']';
        switch (sitems.type) {
            case 'object':
                newItem = prevItem || (0, defaultValue_1.defaultValue)(sitems, true, undefined, options, ppath);
                if (setDataObj(sitems, newItem, value[i], fixArraySize, options, ppath)) {
                    if (newItem != prevItem) {
                        destArray[destIndex] = newItem;
                    }
                    destIndex++;
                }
                break;
            case 'array':
                newItem = prevItem || (0, defaultValue_1.defaultValue)(sitems, true, undefined, options, ppath);
                if (setDataArray(sitems, newItem, value[i], fixArraySize, options, ppath)) {
                    if (newItem != prevItem) {
                        destArray[destIndex] = newItem;
                    }
                    destIndex++;
                }
                break;
            default:
                if (setDataValue(sitems, destArray, destIndex, value[i])) {
                    destIndex++;
                }
                break;
        }
    }
    return true;
}
/**
 * ustawia dane obiektowe
 *
 * @param {JSONSchema} schema schemat
 * @param {*} parentObject docelowy obiekt
 * @param {*} value nowa wartość
 * @param {*} [Vue] konsktruktor Vue
 * @param {boolean} [fixArraySize] czy ustawić nowy rozmiar tablicy
 * @returns {boolean}czy udało się ustawić
 */
function setDataObj(schema, parentObject, value, fixArraySize, options = IOptions_1.defaultOptions, currentPath = '') {
    const props = schema.properties;
    if (!props) {
        return false;
    }
    if ((value = fixType(schema, value)) === undefined)
        return false;
    for (const key in value) {
        // eslint-disable-next-line no-prototype-builtins
        if (value.hasOwnProperty(key)) {
            const pschema = props[key];
            if (pschema !== undefined) {
                const ppath = currentPath ? currentPath + '.' + key : key;
                const kvalue = value[key];
                switch (pschema.type) {
                    case 'object':
                        {
                            if (kvalue === null) {
                                setDataValue(pschema, parentObject, key, null);
                                continue;
                            }
                            let nparent = parentObject[key];
                            if (nparent === undefined || nparent === null) {
                                setDataValue(pschema, parentObject, key, (0, defaultValue_1.defaultValue)(pschema, false, null, options, ppath) || {});
                                nparent = parentObject[key];
                            }
                            setDataObj(pschema, nparent, kvalue, fixArraySize, options, ppath);
                        }
                        break;
                    case 'array':
                        {
                            if (kvalue === null) {
                                setDataValue(pschema, parentObject, key, null);
                                continue;
                            }
                            let narray = parentObject[key];
                            if (narray === undefined || narray === null) {
                                parentObject[key] = narray = (0, defaultValue_1.defaultValue)(pschema, true, undefined, options, ppath);
                            }
                            setDataArray(pschema, narray, kvalue, fixArraySize, options, ppath);
                        }
                        break;
                    default:
                        setDataValue(pschema, parentObject, key, kvalue);
                        break;
                }
            }
        }
    }
    return true;
}
exports.default = setData;
/*
function setDataKey(schema: JSONSchema, parent: any, key: any, value: any): boolean {
  if (schema.type === 'object') {
    if (typeof value === 'object') {
      let destobj = parent[key];
      if (destobj === undefined) {
        parent[key] = destobj = defaultValue(schema, true);
      }
      const keys = Object.keys(value);
      const props = schema.properties as any;
      const dkeys = Object.keys(props);
      for (const skey of keys) {
        const dschema = props[skey];
        if (dschema !== undefined) {
          setData(dschema, destobj, skey, value[skey]);
        }
      }
      return true;
    } else {
      return false;
    }
  } else if (schema.type === 'array') {
    if (Array.isArray(value)) {
      let destobj = parent[key];
      if (destobj === undefined) {
        parent[key] = destobj = defaultValue(schema, true);
      }
      const items = schema.items as JSONSchema;
      for (let i = 0; i < value.length; i++) {
        setData(items, destobj, i, value[i]);
      }
      return true;
    } else {
      return false;
    }
  } else {
    switch (schema.type) {
      case 'integer':
      case 'number':
      case 'money':
        if (typeof value === 'number') {
          parent[key] = value;
          return true;
        } else {
          return false;
        }
      case 'string':
        if (typeof value === 'string') {
          parent[key] = value;
          return true;
        } else {
          return false;
        }
      case 'boolean':
        if (typeof value === 'boolean') {
          parent[key] = value;
          return true;
        } else {
          return false;
        }
      default:
        return false;
    }
  }
}
*/
//# sourceMappingURL=setData.js.map